module.exports = __webpack_public_path__ + "static/media/IndWorkCol.c68a7958.png";